import { CHANNEL, SYSTEM, COOKIES } from 'utils/constants'
import { getCurrentChannel } from 'utils/utils'
import { useCookieNoticeState } from '@/store/context/cookie-notice-context'
import { cookieCategoryIsActive } from '@/modern/utils/cookies'

export default () => {
  const { cookies } = useCookieNoticeState()
  const isActive = cookieCategoryIsActive(cookies, COOKIES.CHANNEL)

  const formatChannelForLead = () => {
    let channel
    const cookieChannel = isActive && getCurrentChannel()

    switch (cookieChannel) {
      case SYSTEM.MEUCARANGO:
        channel = CHANNEL.MEUCARANGO
        break
      case SYSTEM.COMPREAUTO:
        channel = CHANNEL.COMPREAUTO
        break
      case SYSTEM.ITAJAICARROS:
        channel = CHANNEL.ITAJAICARROS
        break
      case SYSTEM.FLORIPACARROS:
        channel = CHANNEL.FLORIPACARROS
        break
      case SYSTEM.BLUCARROS:
        channel = CHANNEL.BLUCARROS
        break
      case SYSTEM.JOINVILLECARROS:
        channel = CHANNEL.JOINVILLECARROS
        break
      default:
        channel = CHANNEL.WEBMOTORS
        break
    }

    return channel
  }

  const formatMessage = (hasCarDelivery, leadInfo, carOrBike) => {
    const formattedDate = `${leadInfo.day.day} de ${leadInfo.day.month}`
    const formattedFullTime = `${leadInfo.formattedTime.formattedHour}:${leadInfo.formattedTime.formattedMinutes}`
    const message = hasCarDelivery
      ? `Olá, gostei ${carOrBike}! Quero agendar uma videochamada para o dia ${formattedDate}, às ${formattedFullTime} e negociar online
            com o CarDelivery. Por favor retorne com mais informações.`
      : `Olá, gostei ${carOrBike} e quero agendar uma videochamada para o dia ${formattedDate}, às ${formattedFullTime} para conhecê-lo. Por favor,
            retorne com mais informações.`

    return message
  }

  const formatAdobeGuid = () => {
    let adobeGuid = null
    if (
      process.env.NODE_ENV != 'development' &&
      typeof Visitor !== 'undefined' &&
      Visitor != null &&
      Visitor.getInstance('3ADD33055666F1A47F000101@AdobeOrg') != null &&
      Visitor.getInstance('3ADD33055666F1A47F000101@AdobeOrg') != undefined &&
      Visitor.getInstance(
        '3ADD33055666F1A47F000101@AdobeOrg'
      ).getMarketingCloudVisitorID() != null &&
      Visitor.getInstance(
        '3ADD33055666F1A47F000101@AdobeOrg'
      ).getMarketingCloudVisitorID() != undefined
    ) {
      adobeGuid = Visitor.getInstance(
        '3ADD33055666F1A47F000101@AdobeOrg'
      ).getMarketingCloudVisitorID()
    }

    return adobeGuid
  }

  return {
    formatChannelForLead,
    formatMessage,
    formatAdobeGuid,
  }
}
